import { basemapFormatFromUrl, getBasemap } from 'features/maps/utils/basemap'
import { KeplerMapStyle, MapStyleType } from '../ui/KeplerGl/types'
import { Basemap } from 'features/maps/types'

const CUSTOM_STYLE_ID_PREFIX = 'custom:'
export function basemapIdToStyleId(basemapId: string) {
  return `${CUSTOM_STYLE_ID_PREFIX}${basemapId}`
}

export function basemapToMapStyle(basemap: Basemap): KeplerMapStyle {
  const styleOrUrl = getBasemap(basemap.settings).style
  const mapStyle: KeplerMapStyle = {
    type: MapStyleType.CUSTOM,
    id: basemapIdToStyleId(basemap.id),
    label: basemap.name,
    icon: basemap.thumbnail,
    layerGroups: [],
    disabled: basemap.disabled,
    customAttribution: basemap.attribution,
    originalUrl: basemap.settings.url
  }
  if (typeof styleOrUrl === 'string') {
    mapStyle.url = styleOrUrl
  } else {
    mapStyle.style = styleOrUrl
  }
  return mapStyle
}

export function basemapFromKeplerMapStyle(style: KeplerMapStyle): Basemap {
  const url = style.url || style.originalUrl || ''
  const basemap: Basemap = {
    id: style.id.substring(CUSTOM_STYLE_ID_PREFIX.length),
    type: basemapFormatFromUrl(url),
    name: style.label,
    thumbnail: style.icon || '',
    settings: {
      url
    }
  }
  return basemap
}
